/**
 * Чем опознать человека за аккаунтом вне игры: почта у аккаунтов, заведенных
 * по почте, логин Яндекса у вошедших через Яндекс ID. Показывается только
 * админам в профиле пользователя — сервер кладет эти поля лишь в админский
 * ответ (toAdminUserResponse).
 */

export const USER_AUTH_METHODS = {
  EMAIL: 'email',
  YANDEX: 'yandex',
};

// uid Яндекс Паспорта (поле id ответа login.yandex.ru/info) — всегда число.
// Синтетические аккаунты держат в yandexId свои метки (dev_, bot_, mock_,
// mcp_, audit_test_user) и через Яндекс не входили никогда — строку
// «логин Яндекса» им показывать не о чем
const YANDEX_UID_PATTERN = /^\d+$/;

/**
 * Логин из ответа login.yandex.ru/info. Только настоящий login: display_name
 * пользователь меняет в Яндексе когда угодно, и по нему аккаунт не найти.
 * @param {Object} [yandexInfo] - ответ login.yandex.ru/info
 * @returns {string|null}
 */
export const readYandexLogin = (yandexInfo) => {
  const login = yandexInfo?.login;
  if (typeof login !== 'string') {
    return null;
  }
  const trimmedLogin = login.trim();
  return trimmedLogin || null;
};

/**
 * Способ входа аккаунта — по тому, какие учетные данные у него есть.
 * @param {{email?: string, yandexId?: string, yandexLogin?: string, isBot?: boolean}} [user]
 * @returns {string|null} USER_AUTH_METHODS или null (бот, синтетический аккаунт)
 */
export const getUserAuthMethod = (user) => {
  if (!user || user.isBot) {
    return null;
  }
  if (user.email) {
    return USER_AUTH_METHODS.EMAIL;
  }
  if (user.yandexLogin || (typeof user.yandexId === 'string' && YANDEX_UID_PATTERN.test(user.yandexId))) {
    return USER_AUTH_METHODS.YANDEX;
  }
  return null;
};

export const MISSING_YANDEX_LOGIN_TEXT = 'Не сохранен — появится после следующего входа через Яндекс';

/**
 * Строка профиля для админа.
 * @param {{authMethod?: string, email?: string, yandexLogin?: string}} [profile] - админский ответ профиля
 * @returns {{label: string, value: string|null, missingText?: string}|null}
 */
export const getProfileAuthIdentity = (profile) => {
  if (profile?.authMethod === USER_AUTH_METHODS.EMAIL && profile.email) {
    return {label: 'Почта', value: profile.email};
  }
  if (profile?.authMethod === USER_AUTH_METHODS.YANDEX) {
    // Логин начали сохранять не с первого дня: у давних аккаунтов он
    // появится, когда игрок снова войдет через Яндекс
    return {
      label: 'Логин Яндекса',
      value: profile.yandexLogin || null,
      missingText: MISSING_YANDEX_LOGIN_TEXT,
    };
  }
  return null;
};
